<div class="w-[1200px]">
  <h2 class="font-semibold text-lg mb-4">{{ title$ | async }}</h2>

  <div class="flex gap-x-2 mb-4">
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="farmForm.controls.name"
      >Наименование</tui-input
    >
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="farmForm.controls.nameFromInvoice"
      >Название в инвойсе</tui-input
    >
    <div class="w-2/12 items-center flex gap-x-2">
      <tui-toggle [formControl]="farmForm.controls.broker"></tui-toggle
      >Посредник
    </div>
    <div class="w-2/12 items-center flex gap-x-2">
      <tui-toggle [formControl]="farmForm.controls.taxNonPayer"></tui-toggle>Не
      плательщик НДС
    </div>
  </div>
  <div class="flex gap-x-2 mb-4">
    <app-multi-select
      [tuiTextfieldCleaner]="true"
      class="w-6/12"
      [formControl]="farmForm.controls.flowerTypesJson"
      [items]="flowerTypes$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [labelOutside]="false"
      label="Вид растений"
    ></app-multi-select>
    <div class="w-1/12 items-center flex gap-x-2">
      <tui-toggle [formControl]="farmForm.controls.imported"></tui-toggle>Импорт
    </div>
    <tui-input-number
      class="w-2/12"
      tuiTextfieldSize="m"
      [formControl]="farmForm.controls.precoolingRate"
      >Ставка прекулинга</tui-input-number
    >
    <app-autocomplete
      class="w-1/12"
      label="Валюта"
      [labelOutside]="false"
      [formControl]="farmForm.controls.currencyLetter"
      [itemValue]="'letterCode'"
      [itemText]="'name'"
      [items]="CURRENCIES"
    ></app-autocomplete>
  </div>
  <div class="w-full mb-4">
    <tui-input tuiTextfieldSize="m" [formControl]="farmForm.controls.comment"
      >Комментарий
    </tui-input>
  </div>

  <div
    *ngFor="
      let address of farmForm.controls.addressesJson.controls;
      let index = index;
      let last = last
    "
    class="mb-4 flex gap-x-2"
  >
    <app-autocomplete
      class="w-1/12"
      label="Cтрана"
      [labelOutside]="false"
      [items]="countries()"
      [itemText]="'name'"
      [itemValue]="'letterCode'"
      [itemSearch]="'search'"
      [formControl]="address.controls.countryLetter"
    ></app-autocomplete>
    <div class="w-4/12" tuiGroup [collapsed]="true">
      <tui-input
        class="tui-group__inherit-item w-[calc(100%-25px-20px)] tui-group__auto-width-item"
        tuiTextfieldSize="m"
        [formControl]="address.controls.latLng"
        >Координаты (lat,lng)</tui-input
      >
      <button
        class="w-[25px] tui-group__inherit-item tui-group__auto-width-item"
        (click)="selectLocation$.next(index)"
        tuiIconButton
        size="m"
        icon="tuiIconMap"
      ></button>
    </div>
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [tuiTextfieldLabelOutside]="false"
      [formControl]="address.controls.address"
      >Адрес</tui-input
    >
    <tui-input
      class="w-2/12"
      tuiTextfieldSize="m"
      [tuiTextfieldLabelOutside]="false"
      [formControl]="address.controls.gateAccessCode"
      >Код от ворот</tui-input
    >
    <div class="flex gap-x-2 items-center w-1/12">
      <button
        (click)="removeAddress(index)"
        appearance="accent"
        tuiIconButton
        size="s"
        icon="tuiIconTrash"
      ></button>
      @if (last) {
        <button
          (click)="addAddress()"
          tuiIconButton
          size="s"
          icon="tuiIconPlus"
        ></button>
      }
    </div>
  </div>

  <div>
    @if (!farmForm.controls.addressesJson.controls.length) {
      <button
        (click)="addAddress()"
        class="my-4"
        tuiButton
        size="s"
        icon="tuiIconPlus"
      >
        Добавить адрес
      </button>
    }
  </div>

  <h3 class="font-semibold mb-2">Сотрудники</h3>
  <div class="mb-2 max-h-[300px] overflow-y-scroll hide-scrollbar">
    @for (
      member of farmForm.controls.members.controls;
      track index;
      let last = $last;
      let index = $index
    ) {
      <app-organization-member
        [last]="last"
        [memberForm]="member"
        (create)="addMember()"
        (remove)="removeMember(index)"
      ></app-organization-member>
    } @empty {
      <button size="s" tuiButton icon="tuiIconPlus" (click)="addMember()">
        Добавить сотрудника
      </button>
    }
  </div>

  <div class="flex justify-between mt-4">
    <div class="w-2/12 flex gap-x-2 items-center">
      <app-checkbox
        [formControl]="farmForm.controls.publicAccess"
      ></app-checkbox>
      Публичный доступ
    </div>
    <div>
      <button
        (click)="context.$implicit.complete()"
        size="m"
        appearance="outline"
        tuiButton
        class="mr-2"
      >
        Отмена
      </button>
      <button
        (click)="save$.next()"
        [disabled]="!farmForm.valid"
        tuiButton
        size="m"
      >
        Сохранить
      </button>
    </div>
  </div>
</div>
